export default __webpack_public_path__ + "static/media/icon-activity-loginout.f78ffb7f.svg";